import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker, Polygon } from "@react-google-maps/api";
import { domain, googleMapsApiKey } from "../../Urls/Services/Api_urls";
import { Box, FormLabel, Grid, InputAdornment, TextField } from "@material-ui/core";
import Swal from "sweetalert2";
import image from "../../assets/MapMarker.png"
import { PinAlt } from "iconoir-react";

const MapComponent = (props) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [shouldSendRequest, setShouldSendRequest] = useState(true);
  const [placeDetails, setPlaceDetails] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [zoom, setZoom] = useState("18");
  const url = domain + "/portal/cover/";
  const estrato = window.sessionStorage.getItem("estrato");
  let direc = "";
 
  let coordenadasPoligono1 = props.coordenadasPoligono;
  const [path, setPath] = useState([]);
  const [center, setcenter] = useState({
    lat: 3.3750139010000453,
    lng: -76.564036637999948,
  });

  useEffect(() => {
    console.log(props);
    if (coordenadasPoligono1 != undefined) {
      const newPath = coordenadasPoligono1.map((coordenada) => ({
        lat: coordenada[1],
        lng: coordenada[0],
      }));
      setPath(newPath);
      setcenter(newPath[0]);
      setZoom(props.zoom);
    }
  }, coordenadasPoligono1);

  const handleMapClick = (event) => {
    if (window.google && window.google.maps) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setSelectedLocation({ lat, lng });
      setLatitude(lat);
      setLongitude(lng);
    }
  };

  // const handleCenterMap = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const lat = position.coords.latitude;
  //         const lng = position.coords.longitude;
  //         setcenter({ lat, lng });
  //         setZoom("18");
          
  //       },
  //       (error) => {
  //         console.error('Error al obtener la ubicación:', error);
  //       }
  //     );
  //   } else {
  //     console.error('El navegador no soporta geolocalización.');
  //   }
  // };

  const ValidationMap = (e) => {
    e.preventDefault();

    const credentials = { latitude, longitude, address };
    if (latitude !== "") {
      try {
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(credentials),
        }).then(async function (response) {
          if (response.status === 200) {
            direc = await response.json();
            console.log(direc);
          }
          if (direc.status === 200) {
            Swal.fire({
              title: "Usted tiene cobertura",
              html: "Pasemos a registrar el servicio <br> <b></b>",
              icon: "success",
              timer: 2500,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector("b");
                setInterval(() => {
                  b.textContent = Swal.getTimerLeft();
                }, 100);
              },
            }).then(() => {
              window.location.href = props.ruta;
              window.sessionStorage.setItem("direction", 'REF ' + address);
              window.sessionStorage.setItem("city_owner", direc.data.city);
              window.sessionStorage.setItem(
                "estrato",
                estrato !== undefined && estrato !== null && estrato !== 0 ? estrato : "3"
              );
              window.sessionStorage.setItem("cdo", direc.data.cdo);
              window.sessionStorage.setItem("zone", direc.data.zone);
              if (direc.localization) {
                window.sessionStorage.setItem("localization", JSON.stringify(direc.localization));
              }
            });
          } else {
            Swal.fire({
              title: "Te debemos una disculpa",
              text: "Estamos proyectando implementar Fibra Óptica en tu zona",
              icon: "info",
              confirmButtonText: "Intentar",
            });
          }
        });
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "No hay disponibilidad en el momento",
          icon: "error",
          confirmButtonText: "Intentar",
        });
        console.error(error);
      }
    } else {
      Swal.fire({
        title: "Marca algun punto en el mapa",
        icon: "error",
        confirmButtonText: "Intentar",
      });
    }
  };

  if (shouldSendRequest) {
    return (
      <>

        <LoadScript googleMapsApiKey={googleMapsApiKey}>
          <GoogleMap
            mapContainerStyle={{ width: props.width, height: "600px", borderRadius:"1rem" }}
            zoom={props.zoom}
            center={center}
            onClick={handleMapClick}
          >
            {selectedLocation && (
              <Marker
                position={{
                  lat: selectedLocation.lat,
                  lng: selectedLocation.lng,
                }}
                icon={{
                  url: image, // Ruta de la imagen
                  scaledSize: { width: 50, height: 50 }, // Tamaño personalizado
                }}
              />
            )}

          {/* {currentLocation && (
            <Marker
              position={{ lat: currentLocation.lat, lng: currentLocation.lng }}
            />
          )} */}

            <Polygon
              paths={path}
              options={{
                fillColor: "#771EEB",
                fillOpacity: 0.5,
                strokeColor: "#771EEB",
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
            />
          </GoogleMap>
        </LoadScript>

        <div style={{ height: 20 }} />
        <div style={{ display: props.display }}>
          <h5>Selecciona tu ubicación en el mapa, pulsa dos veces sobre el mapa.</h5>
          <form onSubmit={ValidationMap}>
            <TextField
              helperText="Dirección de su residencia"
              placeholder="Via la buitrera km 5, casa 5"
              required
              style={{
                width: "100%",
                marginBottom: "1rem",
                marginLeft: "0.5rem",
                marginRight: "0.5rem",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
              value={address}
              label="Dirección"
              size="small"
              onChange={(e) => setAddress(e.target.value)}
              
            />
              <div className="flex justify-center items-center">
            <button  className="flex  items-center mt-5 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..." variant="contained" type="submit">
            <PinAlt/>
              Buscar
            </button>
            {/* <a className="btn btn72" onClick={handleCenterMap}>Centrar en mi Ubicación</a> */}
          
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default MapComponent;
